// src/components/common/LoadingSpinner.tsx
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const Spinner = styled('div')`
  border: 4px solid rgba(0, 164, 224, 0.1);
  border-top: 4px solid #00A4E0;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingSpinner = () => (
  <Box 
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'inherit'
    }}
  >
    <Spinner />
  </Box>
);

export default LoadingSpinner;